import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProcedureConfiguration } from '../models/procedure-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class ProcedureConfigurationService {
  private url: string = environment.urls.baseApiUrl + '/ProcedureConfiguration';

  constructor(
    private http: HttpClient
  ) { }

  public read(): Observable<ProcedureConfiguration> {
    return this.http.get<ProcedureConfiguration>(this.url);
  }

  public update(id: number, configuration: ProcedureConfiguration): Observable<ProcedureConfiguration> {
    return this.http.put<ProcedureConfiguration>(this.url + '/' + id.toString(), configuration);
  }
}
